/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

//----------------------------------------------------------------------//
// MATERIAL UI
//----------------------------------------------------------------------//
import Grid from '@material-ui/core/Grid/Grid';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
// import { HeadMessage } from '../../components/HeadMessage/HeadMessage';
import { HeadMessage } from 'views/SentRequestsReview/components/HeadMessage/HeadMessage.js';
import styles from './AssetQuoteRequest.module.scss';

//----------------------------------------------------------------------//
// UTILS
//----------------------------------------------------------------------//

@translate()
export default class AssetQuoteRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { t, data } = this.props;
    const { details } = data;
    const { contract } = details;
    const asset = contract.assets[0];

    return (
      <Grid className={styles['notifications-grid']} container={true}>
        <div className={styles['asset-quote-request']}>
          <div className={styles['container']}>
            <HeadMessage data={data} />

            <div className={styles['list-container']}>
              <b>{t('general:assets.labels.details')}</b>
              <ul>
                <li>
                  {t('general:assets.labels.number')}:{' '}
                  <Link to={`/assets/${asset.id}`}>{asset.asset_number}</Link>
                </li>
                <li>
                  {t('general:manufacturer')}: {asset.manufacturer}
                </li>
                <li>
                  {t('general:model')}: {asset.model}
                </li>
                <li>
                  {t('general:description')}: {asset.description}
                </li>
                <li>
                  {t('general:labels.serial_number')}: {asset.serial_number}
                </li>
                <li>
                  {t('general:assets.labels.options_fitted')}: {asset.owned_options_fitted_text}
                </li>
              </ul>
            </div>

            <div className={styles['list-container']}>
              <b>{t('general:assets.quotation_needed_for')}</b>
              <ul>
                <li>
                  {t('general:assets.renting')}: {details.renting ? 'Yes' : 'No'}
                </li>
                <li>
                  {t('general:assets.buying_new')}: {details.buying_new ? 'Yes' : 'No'}
                </li>
                <li>
                  {t('general:assets.buying_used')}: {details.buying_used ? 'Yes' : 'No'}
                </li>
              </ul>
            </div>

            <div className={styles['list-container']}>
              <b>{t('general:labels.additional_info')}</b>
              <ul>
                <li>{details.additional_info}</li>
              </ul>
            </div>
          </div>
        </div>
      </Grid>
    );
  }
}
